<template>
  
  <div class="d-flex justify-content-center">
    <div class="share-widget-wrapper js-share-widget position-relative d-inline-block" :class="{'active': showWidget}">       
        <h2 id="share-story" class="sr-only">{{ $t(iKey('ui_labels', 'ui', 'social_share_label')) }}</h2>
        <button 
            class="btn-reset mb-2" 
            :aria-expanded="'true' ? showWidget : 'false'" 
            v-on:click="showWidget = !showWidget"
            v-on:blur="delayHideWidget">{{ $t(iKey('ui_labels', 'ui', 'social_share_label')) }} <SVGShare class="share-icon"></SVGShare></button>
        <div class="social-widget">
            <ul aria-labelledby="share-story" class="list-unstyled p-2 px-3 mb-1">
                <li>
                    <a class="social-link" target="_blank" frel="nofollow noopener noreferrer" 
                        :href="'https://www.facebook.com/sharer/sharer.php?u=' + location">
                    <SVGFacebook class="share-icon-fb"></SVGFacebook> Facebook</a>
                </li>
                <li>
                    <a class="social-link" target="_blank" rel="nofollow noopener noreferrer" 
                        :href="'https://twitter.com/intent/tweet?text=' + $t(iKey('share','social','share_description_twitter')) + '&via=' + twitterVia +'&url=' + location">
                    <SVGTwitter class="share-icon-tw"></SVGTwitter> Twitter</a>
                </li>
            </ul>
        </div>
    </div>
  </div>
  
</template>

<script>
import SVGShare from '@/assets/icons/share.svg'
import SVGFacebook from '@/assets/icons/facebook.svg'
import SVGTwitter from '@/assets/icons/twitter.svg'

export default {
  name: 'SocialShare',
  components: {
    SVGShare,
    SVGFacebook,
    SVGTwitter
  },
  data: () => {
      return {
          showWidget: false
      }
  },
  computed: {
     location() {
         return window.location.href
     },
     twitterVia() {
         if(this.$i18n.locale == 'en'){
             return 'CMHR_News'
         } else {
             return 'mcdp'
         }
     }
  },
  methods: {
      delayHideWidget() {
          setTimeout(() => this.showWidget = false, 100);
      }
  }
}
</script>

<style scoped>

button {
    color: #968c82;
    font-size: 16px;
    font-family: 'UniversLTPro-55Roman';
    transition: color 0.3s;
}
.share-icon {
    width: 22px;
    margin-left: 3px;
    transition: left 0.3s;
    left: 0;
    position: relative;
}
.share-icon path {
    fill: #968c82;
    transition: fill 0.3s;
}

.share-icon-fb {
    width: 8px;
    margin-right: 9px;
}
.share-icon-tw {
    width: 15px;
    margin-right: 2px;
}

button:hover,
.share-widget-wrapper.active button {
    color: #382e2b;
}
button:hover .share-icon path,
.share-widget-wrapper.active .share-icon path {
    fill: #382e2b;
}
button:hover .share-icon,
.share-widget-wrapper.active .share-icon {
    left: 4px;
}

.share-widget-wrapper {
    height: 150px;
}

.share-widget-wrapper.active .social-widget {
    display: block;
}

.share-widget-wrapper .social-widget {
    position: absolute;
    right: -15px;
    
    display: none;
    background-color: #fff;
    box-shadow: 0 0 0.125rem 0.0625rem rgba(0,0,0,.2);
}
.share-widget-wrapper .social-widget li {
    padding-top: 5px;
}
.share-widget-wrapper .social-widget a {
    font-size: 14px;
    font-family: 'UniversLTPro-55Roman';
    color: black;
}


.share-widget-wrapper .social-widget::before {
    position: absolute;
    top: -.3125rem;
    right: 1.25rem;
    display: block;
    width: .625rem;
    height: .625rem;
    content: "";
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    border: 1px solid #fff;
    background-color: #fff;
    box-shadow: -0.125rem -0.125rem 0.125rem -0.0625rem rgba(0,0,0,.2);
}

</style>

